<div class="ui-kit-tag-list" data-qa-block="tag-list">
  <button
    *ngFor="let reportType of reportTypeFilters"
    type="button"
    class="ui-kit-tag"
    [attr.data-qa-button]="'select-' + reportType.qaAttr"
    [class.tag__selected]="selectedReportType?.value === reportType.value"
    (click)="selectReportType(reportType)"
  >
    {{ reportType.name | translate }}
  </button>
</div>
